import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getLeaves = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/my-leaves${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};
export const getTeamLeaves = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/allLeaves${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const createLeave = (data, token) =>
  axios.post(`${baseUrl}/employee-leave`, data, {
    headers: {
      authorization: token,
    },
  });

export const approveLeave = (id, data, token) =>
  axios.patch(`${baseUrl}/approve-leave/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const updateLeave = (id, data, token) =>
  axios.patch(`${baseUrl}/employee-leave/${id}`, data, {
    headers: {
      authorization: token,
    },
  });

export const getLeaveById = (id, token) =>
  axios.get(`${baseUrl}/employee-leave/${id}`, {
    headers: {
      authorization: token,
    },
  });
export const getLeaveSummary = (query, token) => {
  let qs = buildQuery(query);
  return axios.get(`${baseUrl}/leave-summary${qs}`, {
    headers: {
      authorization: token,
    },
  });
};
